<template>
  <v-group
    :config="iconConfig"
    @click="onIconClick"
    @tap="onIconClick"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut" >

    <v-path
      v-if="iconType"
      :config="pathConfig"
      :name="iconName">
    </v-path>

    <v-text v-if="buttonText" :config="buttonTextConfig">
    </v-text>
  </v-group>
</template>

<script>
// TODO: mouseover und out muss sich auf hitFunc beziehen
// TODO: name="editSettingsIcon" is usefull for global event detection

export default {
  props: {
    x: {},
    y: {},
    offsetX: {
      default: 0
    },
    offsetY: {
      default: 0
    },
    iconType: {
      default: 'add'
    },
    iconName: {
      default: 'no-name'
    },
    buttonText: {
      default: null
    }
  },
  data: () => ({
    path: ''
  }),
  mounted() {
    // TODO: Import from json
    switch ( this.iconType ) {
      case 'edit':
      this.path = 'M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z';
      break;

      case 'add':
      this.path = 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';
      break;

      case 'settings':
      this.path = 'M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z';
      break;

      case 'collect':
      this.path = 'M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z';
      break;

      default:
      this.path = ''
      break
    }
  },
  computed: {
    iconConfig() {
      let x = this.x || 0;
      let y = this.y || 0;
      let offsetX = this.offsetX || 0;
      let offsetY = this.offsetY || 0;
      return {
        x,
        y,
        offsetX,
        offsetY,
      };
    },
    pathConfig() {
      return {
        data: this.path,
        fill: '#ffffff',
        stroke: '#000000',
        strokeWidth: 15,
        scale: { x: 0.05, y: 0.05 },
        hitFunc: function(context) {
          /* has to be function (this) */
          context.beginPath();
          context.arc( 0, 0, 512, 0, Math.PI * 2, true);
          context.closePath();
          context.fillStrokeShape(this);
        }
      }
    },
    buttonTextConfig() {
      return {
        fill: 'white',
        offsetX: -30,
        offsetY: -6,
        fontSize: 13,
        fontStyle: 'bold',
        text: this.buttonText,
      }
    }
  },
  methods: {
    onIconClick(event) {
      this.$emit('click', event)
    },
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    }
  }
}
</script>
